module.exports = __webpack_public_path__ + "static/media/rs-gh.664e872a.svg";